import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import {
  ButtonsContainerComponent,
  isDisabled$,
  TypedFormControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';
import { type IPartner } from '@principle-theorem/principle-core/interfaces';
import { Region, getEnumValues } from '@principle-theorem/shared';

export type PartnerFormData = Pick<IPartner, 'name' | 'regions'>;

@Component({
  selector: 'pr-partner-add-dialog',
  templateUrl: './partner-add-dialog.component.html',
  styleUrls: ['./partner-add-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    NgMaterialModule,
    ReactiveFormsModule,
    ButtonsContainerComponent,
  ],
})
export class PartnerAddDialogComponent {
  private _dialogRef = inject(
    MatDialogRef<PartnerAddDialogComponent, Partial<IPartner> | undefined>
  );

  regions = getEnumValues(Region);
  form = new TypedFormGroup<PartnerFormData>({
    name: new TypedFormControl('', [Validators.required]),
    regions: new TypedFormControl([], [Validators.required]),
  });
  isDisabled$ = isDisabled$(this.form);

  submit(): void {
    if (!this.form.valid) {
      return;
    }
    this._dialogRef.close(this.form.getRawValue());
  }
}
